import { render, staticRenderFns } from "./SnacksPane.vue?vue&type=template&id=13eafc72&scoped=true&"
import script from "./SnacksPane.vue?vue&type=script&lang=js&"
export * from "./SnacksPane.vue?vue&type=script&lang=js&"
import style0 from "./SnacksPane.vue?vue&type=style&index=0&id=13eafc72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13eafc72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VLayout,VSnackbar})
